{
  "resourceType": "ValueSet",
  "status": "draft",
  "name": "SourceKindValueSet",
  "id": "source-kind-vs",
  "title": "Panel Health Source Kind Value Set",
  "description": "Allowed Panel Health source kinds.",
  "version": "0.0.1",
  "url": "https://casetech.app/fhir/ValueSet/source-kind-vs",
  "compose": {
    "include": [
      {
        "system": "https://casetech.app/fhir/CodeSystem/source-kind"
      }
    ]
  }
}
